import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createCategory,
  getAProductCategory,
  resetState,
  updateAProductCategory,
} from "../features/pcategory/pcategorySlice";
let schema = yup.object().shape({
  title: yup.string().required("Category Name is Required"),
});
const Addcat = ({ editId, editMode, onSuccess }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getPCatId = editId || location.pathname.split("/")[3];
  const navigate = useNavigate();
  const isInModal = location.state?.fromModal;
  const newCategory = useSelector((state) => state.pCategory);
  const {
    isSuccess,
    isError,
    isLoading,
    createdCategory,
    categoryName,
    updatedCategory,
  } = newCategory;
  useEffect(() => {
    if (getPCatId !== undefined) {
      dispatch(getAProductCategory(getPCatId));
    } else {
      dispatch(resetState());
    }
  }, [getPCatId]);
  useEffect(() => {
    if (isSuccess && createdCategory) {
      toast.success("Category Added Successfullly!");
      // Reset state to prevent multiple calls
      dispatch(resetState());
      if (onSuccess) {
        onSuccess();
      }
      if (!isInModal) {
        navigate("/admin/catalog");
      }
    }
    if (isSuccess && updatedCategory) {
      toast.success("Category Updated Successfullly!");
      // Reset state to prevent multiple calls
      dispatch(resetState());
      if (onSuccess) {
        onSuccess();
      }
      if (!isInModal) {
        navigate("/admin/catalog");
      }
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdCategory, updatedCategory, onSuccess, dispatch]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: categoryName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getPCatId !== undefined) {
        const data = { id: getPCatId, pCatData: values };
        dispatch(updateAProductCategory(data));
        dispatch(resetState());
      } else {
        dispatch(createCategory(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });
  return (
    <div>
      <h3 className="mb-4  title">
        {editMode || (getPCatId !== undefined) ? "Edit" : "Add"} Category
      </h3>
      <div className="w-full">
        <form action="" onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <div className="w-full">
            <CustomInput
              type="text"
              label="Enter Product Category"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
              id="brand"
            />
          </div>
          <div className="error text-sm">
            {formik.touched.title && formik.errors.title}
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5 w-full md:w-auto py-2 px-4"
            type="submit"
          >
            {editMode || (getPCatId !== undefined) ? "Edit" : "Add"} Category
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addcat;
